import React from "react";
import { useCart } from "../context/CartContext";
import { fmtCLP } from "../lib/api";
import { ShoppingCart, Sparkles } from "lucide-react";

export default function ProductCard({ product, onCustomize }) {
  const { addItem } = useCart();
  const img = product.images?.[0] || "https://images.unsplash.com/photo-1592286927505-1def25115558?w=600&q=80";

  const onAdd = () => {
    if (product.is_customizable && onCustomize) {
      onCustomize(product);
      return;
    }
    addItem({
      product_id: product.id,
      name: product.name,
      price: product.price,
      image: img,
    });
  };

  return (
    <div className="product-card bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col" data-testid={`product-card-${product.id}`}>
      <div className="aspect-square bg-slate-50 relative overflow-hidden">
        <img src={img} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
        {product.is_customizable && (
          <div className="absolute top-3 left-3 bg-[#0EA5E9] text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full inline-flex items-center gap-1 tech-glow">
            <Sparkles size={11} /> Personalizable
          </div>
        )}
      </div>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <div className="font-heading font-bold text-black leading-tight line-clamp-2 min-h-[2.5em]">{product.name}</div>
        <div className="font-heading font-black text-xl text-black">{fmtCLP(product.price)}</div>
        <button
          onClick={onAdd}
          data-testid={`add-to-cart-${product.id}`}
          className="mt-2 w-full bg-black hover:bg-[#0EA5E9] text-white font-bold py-2.5 rounded-full transition-all inline-flex items-center justify-center gap-2 text-sm"
        >
          <ShoppingCart size={15} />
          {product.is_customizable ? "Personalizar" : "Agregar al carrito"}
        </button>
      </div>
    </div>
  );
}
